export const API_MESSAGE_TYPE = {
    BOT: 'BOT',
    CHAT: 'CHAT',
    UNDEFINED: 'UNDEFINED'
};

export const APIMode = {
    CHAT: 'chat',
    BOT: 'bot',
    CHAT_BOT: 'chat_bot'
};

export const APISubmode = {
    MAX: 'MAX',
    MARIAN: 'MARIAN'
};
